import * as React from "react";
import { Hooks } from "@grandvisionhq/carts-v2";
import { toast } from "@grandvisionhq/common";
import { connect, withIntl } from "@grandvisionhq/state";
import { quantity, pause } from "../../../../../CCC/actions.js";
import { getQuantityCall, getProductDataCall, getProductData, getPauseCall } from "../../../../../CCC/selectors.js";
import { CurrentPlan } from "./CurrentPlan.js";
import { useGetPrescriptionSignatures } from "../../../hooks/CCC/Detail/CurrentPlan/hooks/use-get-prescription-signatures.js";
const getEyeSide = (application) => {
  if (!application.length) {
    return {};
  }
  if (application.length > 2) {
    return {
      eyeSide: "both"
    };
  } else if (application.includes("LEFT_EYE")) {
    return {
      eyeSide: "left"
    };
  } else {
    return {
      eyeSide: "right"
    };
  }
};
const CurrentPlanContainer = (props) => {
  const [addToCart, { loading }] = Hooks.useAddToCart();
  const { prescriptionSignatures } = useGetPrescriptionSignatures();
  const handleTopUp = () => {
    if (loading) {
      return;
    }
    const mapSolution = (lineItem) => ({
      sku: lineItem.productId,
      quantity: 1,
      type: "regular"
    });
    const mapContactLenses = (lineItem) => ({
      sku: lineItem.productId,
      quantity: 1,
      type: "contact-lenses",
      typeDetails: {
        eyeSide: getEyeSide(lineItem.application).eyeSide
      }
    });
    const lineItemDrafts = props.subscription.lineItems.map(
      (lineItem) => (
        // application contains an array with eyesides, only present for contact lenses
        lineItem.application.length ? mapContactLenses(lineItem) : mapSolution(lineItem)
      )
    );
    const onError = (errorCodes) => errorCodes.forEach((code) => toast.failed(`cart.${code}`));
    window.localStorage.removeItem("stored_cart");
    addToCart(
      lineItemDrafts,
      void 0,
      onError,
      (e) => onError([e]),
      void 0,
      void 0,
      void 0,
      void 0,
      { prescriptionSignatures }
    );
  };
  return /* @__PURE__ */ React.createElement(
    CurrentPlan,
    {
      ...props,
      getEyeSide,
      handleTopUp,
      reorderLoading: loading
    }
  );
};
const mapStateToProps = (state) => ({
  pauseCall: getPauseCall(state),
  productData: getProductData(state),
  productDataCall: getProductDataCall(state),
  quantityCall: getQuantityCall(state)
});
const mapDispatchToProps = {
  pause,
  quantity
};
const CurrentPlanContainer$1 = connect(mapStateToProps, mapDispatchToProps)(withIntl(CurrentPlanContainer));
export {
  CurrentPlanContainer,
  CurrentPlanContainer$1 as default,
  mapDispatchToProps,
  mapStateToProps
};
//# sourceMappingURL=CurrentPlanContainer.js.map
